import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../DiscountOffer.module.css';
import FeatureCard from './FeatureCard';
import { Typography } from '../../../components/Typography/typography';
import { 
    WhiteStar, 
    WhiteGlobe, 
    NotificationWhite, 
    SupportIconWhite
} from '../../../assets/images/icons';

const FeaturesSection = () => {
    const { t } = useTranslation();
    
    const features = [
        {
            icon: WhiteStar,
            title: t('discount_offer.feature_priority_listings_title'),
            description: t('discount_offer.feature_priority_listings_desc')
        },
        {
            icon: WhiteGlobe,
            title: t('discount_offer.feature_global_reach_title'),
            description: t('discount_offer.feature_global_reach_desc')
        },
        {
            icon: NotificationWhite,
            title: t('discount_offer.feature_notifications_title'),
            description: t('discount_offer.feature_notifications_desc')
        },
        {
            icon: SupportIconWhite,
            title: t('discount_offer.feature_support_title'),
            description: t('discount_offer.feature_support_desc')
        }
    ];

    return (
        <div className={styles.whyStaySection}>
            <Typography
                title={t('discount_offer.why_stay_subscribed')}
                fontSize={28}
                weight="700"
                color="#333"
                style={{ marginBottom: '40px', textAlign: 'center',}}
            />
            
            <div className={styles.featuresGrid}>
                {features.map((feature, index) => (
                    <FeatureCard 
                        key={index}
                        icon={feature.icon}
                        title={feature.title}
                        description={feature.description}
                    />
                ))}
            </div>
        </div>
    );
};

export default FeaturesSection; 